<template>
  <div class="version-info-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1>版本更新记录</h1>
      <p>追踪系统功能迭代与优化历程</p>
    </div>

    <!-- 版本卡片列表 -->
    <div class="versions-list">
      <div 
        v-for="(version, index) in versions" 
        :key="index" 
        class="version-card"
        :class="{ 'current-version': version.isCurrent }"
      >
        <!-- 版本头部 -->
        <div class="version-header">
          <div class="version-title">
            <h2>{{ version.name }}</h2>
            <span v-if="version.isCurrent" class="current-badge">当前版本</span>
          </div>
          <div class="version-date">发布日期：{{ version.date }}</div>
        </div>

        <!-- 版本内容 -->
        <div class="version-content">
          <h3 class="section-title">更新日志</h3>
          <ul class="update-logs">
            <li v-for="(log, logIndex) in version.logs" :key="logIndex" class="log-item">
              <i class="log-icon"></i>
              <span>{{ log }}</span>
            </li>
          </ul>
        </div>

        <!-- 版本标签 -->
        <div class="version-tags">
          <span v-for="(tag, tagIndex) in version.tags" :key="tagIndex" class="tag">{{ tag }}</span>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <footer class="page-footer">
      <a href="https://www.qihangsoftware.cn" target="_blank" class="footer-container">
        <img src="/logo_company.png" alt="起航工作室" class="footer-logo">
        <div class="copyright">
          <p>2024-2025 起航工作室 © 版权所有</p>
        </div>
      </a>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'VersionInfo',
  data() {
    return {
      versions: [
          {
          id: 14,
          name: 'V4.0 beta',
          date: '2026-7-4',
          isCurrent: true,
          tags: [ '优化体验', '修改细节'],
          logs: [
            '实现上传时预览自己上传的文件',
            '严格教师姓名用顿号分隔，有误提示自动修改',
          ],
        },
          {
          id: 13,
          name: 'V3.9 beta',
          date: '2026-5-10',
          isCurrent: false,
          tags: [ '优化体验', '修改细节','修复严重安全问题'],
          logs: [
            '在上传excel中支持多种格式(.xls)',
            '去除上传必须所有sheet非空限制',
            '新增安全补丁-logo随意修改bug修复(严重安全问题)',
          ],
        },
          {
          id: 12,
          name: 'V3.8 稳定版',
          date: '2026-2-1',
          isCurrent: false,
          tags: [ '优化体验', '修改细节'],
          logs: [
            '奖状审批页面可以查看申请人',
            '实现撤销上传页面可以查询每一条记录上传内容',
            '修复时间显示出错bug'
          ],
        },
          {
          id: 11,
          name: 'V3.7 稳定版',
          date: '2025-11-22',
          isCurrent: false,
          tags: [ '优化体验', '修复问题'],
          logs: [
            '新增多个节点日志记录',
            '新增利用pdf.js预览使用说明书',
            '设置着陆页为使用说明书',
            '修复已知bug',
            '支持中文显示撤销上传页面的日期'
          ],
        },
        {
          id: 10,
          name: 'V3.7 beta',
          date: '2025-11-16',
          isCurrent: false,
          tags: ['新增功能', '优化体验', '修复问题'],
          logs: [
            '新增下载查看奖状查询情况',
            '修改菜单栏布局，提升操作便捷性',
            '提升系统稳定性，修复若干已知问题',
            '学科竞赛+流程引擎，功能全面开放',
          ],
        },
          {
          id: 9,
          name: 'V3.6 稳定版',
          date: '2025-10-29',
          isCurrent: false,
          tags: ['修复问题','提升稳定性'],
          logs: [
            '修复主备查询出错bug',
            '修复撤销上传时间出错bug',
            '修复删除模板时未检测关联数据bug',
            '修复菜单栏展开时无法正常显示bug'
          ],
        },
        {
          id: 8,
          name: 'V3.6 beta',
          date: '2025-10-26',
          isCurrent: false,
          tags: ['功能完善', '优化体验'],
          logs: [
            '新增审批失败可回复原因功能',
            '新增审批可查看上传的数据功能',
            '新增学科竞赛删除可删除某个记录功能',
            '实现学科竞赛模板可自行配置功能'
          ],
        },
        {
          id: 7,
          name: "V3.0 beta",
          date: '2025-10-25',
          isCurrent: false,
          tags: ['功能完善', '优化体验','修复问题','功能上线'],
          logs: [
            '支持学科竞赛奖状生成功能',
            '支持教研组长发起审批功能',
            '修复映射表类型有误bug',
            '新增学科竞赛可设置不同类型奖状功能'
          ],
        },
          {
          id: 6,
          name: 'V2.0 beta',
          date: '2025-7-4',
          isCurrent: false,
          tags: ['优化体验','功能完善'],
          logs: [
            '实现开课证明防伪验证二维码',
            '新增二维码查询成功页面',
            '更新ui设计风格，提升视觉体验',
          ],
        },
        {
          id: 5,
          name: 'V1.4 稳定版',
          date: '2025-2-12',
          isCurrent: false,
          tags: ['优化体验','功能完善'],
          logs: [
            '实现开课证明可以单独修改某条记录',
            '修复表格部分样式问题',
            '修复日期换行bug',
          ],
        },
        {
          id: 4,
          name: 'V1.3 稳定版',
          date: '2025-1-25',
          isCurrent: false,
          tags: ['优化体验','功能完善'],
          logs: [
            '实现对当前学期的标注tag',
            '实现学期倒序查询',
            '实现校验提示出错数据功能',
          ],
        },
        {
          id: 3,
          name: 'V1.2 beta',
          date: '2024-11-3',
          isCurrent: false,
          tags: ['优化体验','功能完善'],
          logs: [
            '新增教师端下载证明预览功能',
            '新增模板自定义功能',
            '实现统计时显示角色类型功能',
            '新增统计可以导出excel版功能'
          ],
        },
        {
          id: 2,
          name: 'V1.1 稳定版',
          date: '2024-10-21',
          isCurrent: false,
          tags: ['修复bug','提升稳定性','优化体验'],
          logs: [
            '修复登录状态异常bug',
            '修复登录状态过期bug',
            '修复上传文件校验出错bug',
            '实现查看教师下载情况可按照下载数量排序功能'
          ],
        },
        {
          id: 1,
          name: 'V1.0 beta',
          date: '2024-9-29',
          isCurrent: false,
          tags: ['基础开发','功能上线'],
          logs: [
            '支持上传证明数据自动生成证明功能',
            '支持证明自动分发下载功能',
            '支持word转化pdf的api，实现开具pdf格式的证明',
            '支持统计各类证明开具数量功能',
            '支持配置学期信息功能',
            '支持用户登录等基础架构功能',
            '支持管理员日志等基础安全架构功能'
          ],
        }
      ],
    };
  },
};
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #f8fafc;
  color: #1e293b;
  line-height: 1.6;
  padding-bottom: 60px;
}

/* 页面标题 */
.page-header {
  text-align: center;
  padding: 60px 20px 40px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  margin-bottom: 40px;
  position: relative;
  overflow: hidden;
}

.page-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.1) 0%, transparent 20%),
    radial-gradient(circle at 80% 70%, rgba(16, 185, 129, 0.1) 0%, transparent 20%);
  z-index: 0;
}

.page-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 12px;
  color: #0f172a;
  position: relative;
  z-index: 1;
}

.page-header p {
  font-size: 1.1rem;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

/* 版本列表容器 */
.versions-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 0 20px;
  max-width: 900px;
  margin: 0 auto;
}

/* 版本卡片 */
.version-card {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 30px;
  transition: all 0.3s ease;
  border: 1px solid rgba(226, 232, 240, 0.5);
  position: relative;
  overflow: hidden;
}

.version-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border-color: rgba(226, 232, 240, 0.8);
}

/* 当前版本样式 */
.version-card.current-version::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background-color: #3b82f6;
}

/* 版本头部 */
.version-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f1f5f9;
}

.version-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.version-title h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #0f172a;
}

.current-badge {
  background-color: #3b82f6;
  color: white;
  font-size: 0.8rem;
  padding: 3px 10px;
  border-radius: 20px;
  font-weight: 500;
}

.version-date {
  font-size: 0.9rem;
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 6px;
}

.version-date::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #94a3b8;
}

/* 版本内容 */
.version-content {
  margin-bottom: 25px;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-title::after {
  content: '';
  flex-grow: 1;
  height: 1px;
  background-color: #e2e8f0;
  max-width: 100px;
}

.update-logs {
  list-style: none;
}

.log-item {
  padding: 8px 0;
  font-size: 0.95rem;
  color: #334155;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  transition: color 0.2s ease;
}

.log-item:hover {
  color: #0f172a;
}

.log-icon {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #3b82f6;
  margin-top: 8px;
  flex-shrink: 0;
}

/* 版本标签 */
.version-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 15px;
  border-top: 1px solid #f1f5f9;
}

.tag {
  font-size: 0.8rem;
  padding: 4px 12px;
  border-radius: 20px;
  background-color: #f1f5f9;
  color: #64748b;
  transition: all 0.2s ease;
}

.tag:hover {
  background-color: #e2e8f0;
  color: #334155;
}

/* 页脚 */
.page-footer {
  margin-top: 80px;
  padding: 40px 20px 20px;
  background-color: #0f172a;
  color: #94a3b8;
}

.footer-container {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  max-width: 900px;
  margin: 0 auto;
}

.footer-logo {
  width: 50px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.1);
}

.copyright p {
  font-size: 0.9rem;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-header h1 {
    font-size: 2rem;
  }
  
  .version-card {
    padding: 20px;
  }
  
  .version-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .footer-container {
    flex-direction: column;
    text-align: center;
  }
}
</style>